export function getAsyncSelectSearchApiParam(searchValue) {
  return searchValue ? { search: searchValue } : null
}

export function getAsyncSelectShowSelectedApiParam({
  loadAllApiParams,
  pk = 'value',
  showSelected,
  value,
}) {
  return showSelected && value
    ? { ...loadAllApiParams, [pk]: value.map(item => item.value) }
    : null
}

export function getAsyncSelectShowSelectedApiParamIdPK(params) {
  return getAsyncSelectShowSelectedApiParam({ ...params, pk: 'id' })
}
